
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-deposit",
  components: {},
})
export default class IconDeposit extends Vue {
  @Prop() public width!: number;
  @Prop() public height!: number;
  @Prop() public color!: string;

  constructor() {
    super();
  }
}
